// Models occasionally emit zero-width characters before a path; react-markdown
// percent-encodes them, so both raw and encoded forms are stripped.
const INVISIBLE_PREFIX = /^(?:%E2%80%8[BCD]|%EF%BB%BF|[\u200B-\u200D\uFEFF])+/i

export function inAppHref(href: string | undefined): string | null {
  const clean = href?.replace(INVISIBLE_PREFIX, '')
  return clean && clean.startsWith('/') && !clean.startsWith('//') ? clean : null
}
